import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_PACIFIC_PROMO_FREE_SAMPLE = createFcmDetails('pacific_promo_free_sample', {
	owner: 'Starter Activation',
	context: 'pacific_promo_free_sample',
	description:
		'FCM to show a dynamic value for the number of impressions that the user can get via free promotion credits.',
	template: {
		impressions: 625,
		amount: 25,
		startDate: '2023-03-16T00:00:00.000Z',
		minSignatureCount: 5,
	},
	import: false,
});
